import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '../utils/api';
import { toast } from 'sonner';
import CosmicBackground from '../components/CosmicBackground';
import Logo from '../components/Logo';
import LanguageSelector from '../components/LanguageSelector';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../utils/translations';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });

      setSent(true);
      toast.success("Email trimis! Verifică inbox.");

    } catch (error) {
      toast.error(
        error.response?.data?.detail || "Eroare la trimiterea emailului"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      <CosmicBackground />

      <div
        className="fixed inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-violet-900/20 via-slate-900 to-slate-950 pointer-events-none"
        style={{ zIndex: 1 }}
      />

      {/* Language */}
      <div className="fixed top-4 right-4 z-20">
        <LanguageSelector />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md px-6"
      >
        <div className="glass-card p-8">

          {/* Logo */}
          <div className="flex flex-col items-center mb-8">
            <Logo size="lg" showText={false} className="mb-4" />
            <h1 className="font-heading text-3xl font-bold text-white">
              Resetare parolă
            </h1>
            <p className="text-slate-400 mt-2 text-center">
              Introdu emailul tău și îți trimitem un link de resetare
            </p>
          </div>

          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm text-slate-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="w-full px-4 py-3 bg-slate-950/50 border border-white/10 rounded-lg text-white placeholder:text-slate-500 focus:outline-none focus:border-violet-500/50 focus:ring-1 focus:ring-violet-500/50"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-full font-medium hover:from-violet-500 hover:to-purple-500 transition-all disabled:opacity-50"
              >
                {loading ? "Se trimite..." : "Trimite email"}
              </button>
            </form>
          ) : (
            <div className="text-center text-slate-300">
              <p className="mb-4">
                📩 Ți-am trimis un email cu link-ul de resetare.
              </p>
              <p className="text-sm text-slate-400">
                Verifică inbox sau spam.
              </p>
            </div>
          )}

          <p className="mt-6 text-center text-slate-400 text-sm">
            <Link
              to="/login"
              className="text-violet-400 hover:text-violet-300 font-medium"
            >
              Înapoi la login
            </Link>
          </p>

        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;